import React, { useState } from 'react';
import { Tabs, Tab, Box, Alert } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { LoginForm } from '../components/auth/LoginForm';
import { RegisterForm } from '../components/auth/RegisterForm';
import { useAuthForm } from '../hooks/useAuthForm';
import ThemeToggle from '../components/ThemeToggle';
import TimeDisplay from '../components/TimeDisplay';

const HomePage: React.FC = () => {
    const [tab, setTab] = useState<number>(0);
    const auth = useAuth();
    const formState = useAuthForm();

    if (!auth) {
        return (
            <Box>
                <Alert severity="error">Authentication service is not available</Alert>
            </Box>
        );
    }

    const handleTabChange = (_event: React.SyntheticEvent, newValue: number): void => {
        setTab(newValue);
    };

    return (
        <Box sx={{ 
            width: '100%', 
            maxWidth: 400, 
            margin: '0 auto', 
            pt: 4,
            px: 2
        }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <TimeDisplay />
                <ThemeToggle />
            </Box>
            <Tabs value={tab} onChange={handleTabChange} centered>
                <Tab label="Login" />
                <Tab label="Register" />
            </Tabs>
            <Box sx={{ mt: 2 }}>
                {tab === 0 ? (
                    <LoginForm formState={formState} />
                ) : (
                    <RegisterForm formState={formState} />
                )}
            </Box>
        </Box>
    );
};

export default HomePage;